<template>
    <v-dialog ref="dialog" v-model="dialogModel" max-width="1200" :scrollable="false">

        <v-sheet height="80vh">
            <edit-data-variable :id="variable.id"
                                :type="variable.type"
                                :locales="locales"
                                @change="closeDialog"
                                @exit="closeDialog"
                                :dialog-model="true"
            ></edit-data-variable>
        </v-sheet>

    </v-dialog>
</template>

<script>

import EditDataVariable from "../../DataVariables/components/EditDataVariable";

export default {

    name: "EditVariableDialog",

    components: {
        EditDataVariable
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },
        variable: {
            type: Object,
            required: true,
        },
        locales: {
            type: Array,
            required: true,
        }
    },

    computed: {
        dialogModel: {
            get() {
                return this.value;
            },
            set(bool) {
                this.$emit('input', bool);
            }
        },
    },

    methods: {

        closeDialog() {
            this.$emit('input', false);
        }
    }
}
</script>
